import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { ErrorMessage } from '@as-react/common-types';
import { EventEnum } from '@as-react/common-types';
import { EventUtil } from '@as-react/common-utils';
import { Banner, Box } from '@yonderland/andes-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import BasketAPI from '../../../api/basket/BasketAPI';
import DpeApi from '../../../api/dpe/DpeApi';
import { DateFormat } from '../../../constants/GeneralConstants';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { format, formatDate, getDaysInMonth } from '../../../util/DateUtil';
import FormValidationUtil from '../../../util/FormValidationUtil';
import { DpeVitalityForm } from '../dpe-vitality-form/DpeVitalityForm';
const DpeVitality = ({ onValidationError, onValidationSuccess }) => {
    const { t } = useTranslation(I18N_NAMESPACES.dpe);
    const { defaultRequestParams, servicesApi } = useAemConfig();
    const [responseErrorMessage, setResponseErrorMessage] = useState(null);
    const validateForm = (values) => {
        const { customerNumber, day, month, year } = values;
        const errors = {};
        if (!customerNumber) {
            errors.customerNumber = t(ErrorMessage.REQUIRED);
        }
        else if (!FormValidationUtil.isOfCorrectLength(customerNumber, 10)) {
            errors.customerNumber = t('dpe.vitality.error.invalidNumber');
        }
        else if (!FormValidationUtil.containsOnlyNumbers(customerNumber)) {
            errors.customerNumber = t('dpe.vitality.error.invalidNumber');
        }
        if (!day) {
            errors.day = t(ErrorMessage.REQUIRED);
        }
        if (!month) {
            errors.month = t(ErrorMessage.REQUIRED);
        }
        if (!year) {
            errors.year = t(ErrorMessage.REQUIRED);
        }
        if (day && month && year) {
            const maxDays = getDaysInMonth(Number(year), Number(month));
            if (Number(day) > maxDays) {
                errors.day = t('dpe.vitality.error.invalidNumber');
            }
        }
        if (Object.keys(errors).length > 0) {
            onValidationError(errors);
        }
        return errors;
    };
    const handleVitalityCheckError = (error) => {
        var _a;
        let stateToSet = t(ErrorMessage.GENERAL_VITALITY);
        if (error.response && error.response.status !== 500 && error.response.data) {
            stateToSet = (_a = error.response.data[0]) === null || _a === void 0 ? void 0 : _a.message;
        }
        setResponseErrorMessage(stateToSet);
        onValidationError({
            api: stateToSet,
        });
    };
    const refreshCustomerVouchers = () => BasketAPI.refreshCustomerVouchers(servicesApi, defaultRequestParams)
        .then(() => {
        EventUtil.dispatch(EventEnum.BASKET_CHANGED);
        onValidationSuccess();
    })
        .catch(error => handleVitalityCheckError(error));
    const checkVitality = (requestData, actions) => {
        DpeApi.checkVitality(requestData, servicesApi, defaultRequestParams)
            .then(refreshCustomerVouchers)
            .catch(error => {
            handleVitalityCheckError(error);
        })
            .then(() => {
            actions.setSubmitting(false);
        });
    };
    const handleSubmit = ({ customerNumber, day, month, year }, actions) => {
        setResponseErrorMessage(null);
        const birthDate = new Date(`${year}/${month}/${day}`);
        const requestData = {
            membershipNumber: customerNumber,
            dateOfBirth: formatDate(format(birthDate.toString(), DateFormat.DD_MM_YYYY.value), DateFormat.DD_MM_YYYY.value),
        };
        checkVitality(requestData, actions);
    };
    return (_jsxs(_Fragment, { children: [responseErrorMessage && (_jsx(Box, { paddingBlockEnd: "4", children: _jsx(Banner, { status: "error", text: responseErrorMessage }) })), _jsx(DpeVitalityForm, { onSubmit: handleSubmit, validate: validateForm })] }));
};
export default DpeVitality;
